import { useEffect, useState } from 'react';
import { Group, KhachHang, KhuVuc, TaiKhoan } from '@/types/schemas';
import { QUERY_KEYS } from '@/constants';
import { useCRUD } from '@/hooks';

/**
 * Hook for managing search field states in the bao-cao-so-du-cong-no feature
 *
 * @returns Object with states and setters for search fields
 */
export const useSearchFieldStates = () => {
  const { data: defaultAccounts } = useCRUD<TaiKhoan>({
    endpoint: `${QUERY_KEYS.TAI_KHOAN}/filter_by_code`,
    searchData: { tk: '331' }
  });

  const [account, setAccount] = useState<TaiKhoan[]>([]);

  useEffect(() => {
    if (account.length === 0 && defaultAccounts.length > 0) {
      const targetAccount = defaultAccounts.find(acc => acc.code === '331') || defaultAccounts[0];
      if (targetAccount) {
        setAccount([targetAccount]);
      }
    }
  }, [defaultAccounts]);

  const [customer, setCustomer] = useState<KhachHang | null>(null);

  const [customerGroup1, setCustomerGroup1] = useState<Group | null>(null);
  const [customerGroup2, setCustomerGroup2] = useState<Group | null>(null);
  const [customerGroup3, setCustomerGroup3] = useState<Group | null>(null);

  const [region, setRegion] = useState<KhuVuc | null>(null);

  return {
    account,
    setAccount,

    customer,
    setCustomer,

    customerGroup1,
    setCustomerGroup1,
    customerGroup2,
    setCustomerGroup2,
    customerGroup3,
    setCustomerGroup3,

    region,
    setRegion
  };
};
